import { readPublicEnv } from '@/lib/runtime-env';

/**
 * Tenant switch is a cross-origin navigation (subdomain `<slug>.<base
 * domain>`, resolved server-side), not client state. The base domain can't be
 * inferred from the host, so it ships via PUBLIC_BASE_DOMAIN (cloudformation.yml, mirrors the backend's auth__baseDomain).
 */
const BASE_DOMAIN = readPublicEnv('PUBLIC_BASE_DOMAIN');

if (!BASE_DOMAIN) {
  throw new Error('Missing PUBLIC_BASE_DOMAIN');
}

export function tenantOrigin(slug: string): string {
  const { protocol, host } = window.location;
  const port = host.split(':')[1];
  return `${protocol}//${slug}.${BASE_DOMAIN}${port ? `:${port}` : ''}`;
}

/** Navigate the browser to a tenant's subdomain (full load; the session cookie is shared across the base domain). */
export function goToTenant(slug: string, path = '/'): void {
  window.location.assign(`${tenantOrigin(slug)}${path}`);
}

export function currentTenantSlug(): string | null {
  const hostname = window.location.host.split(':')[0];
  if (hostname === BASE_DOMAIN) {
    return null;
  }
  if (!hostname.endsWith(`.${BASE_DOMAIN}`)) {
    return null;
  }
  return hostname.slice(0, -`.${BASE_DOMAIN}`.length);
}
